import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    TextField,
    Checkbox,
    FormControlLabel,
    Typography,
} from "@mui/material";
import { useState, useEffect } from "react"
import { saveJobTitle } from "../../api";
import { Loader } from "../../HelperFunctions/HelperFunctions";
import { enqueueSnackbar } from "notistack";

const EditActionDialog = ({ open, onClose, mode = "add", data = {}, onSave }) => {

    const [jobTitle, setJobTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isActive, setIsActive] = useState(
        data ? data.IsActive === 1 : false
    );
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (mode === "edit") {
            setJobTitle(data.JobTitle || "");
            setDescription(data.Description || "");
            setIsActive(data.IsActive ? data.IsActive === 1 : false);
        } else {
            setJobTitle("");
            setDescription("");
            setIsActive(false);
        }
    }, [mode, data]);

    const compactTextFieldSx = {
        "& .MuiInputBase-root": {
            height: 30,
            fontSize: "12px",
        },
        "& .MuiInputBase-input": {
            padding: "6px 8px",
            fontSize: "12px",
            fontWeight: 500,
        },
    };

    const handleSubmit = async (type) => {
        try {
            setLoading(true);
            if (!jobTitle) {
                enqueueSnackbar("Job Title is required!", { variant: "warning" });
                return;
            }

            const jobSavePayload = {
                ...(mode === "edit" && { ID: data?.ID }),
                Name: jobTitle,
                Description: description,
                IsActive: isActive ? 1 : 0
            };
            const jobTitleSave = await saveJobTitle(jobSavePayload);
            if (jobTitleSave?.StatusCode === 200) {
                enqueueSnackbar(jobTitleSave?.Status, { variant: "success" });
                if (type !== "saveNew") {
                    onClose();
                    onSave();
                } else {
                    onSave();
                    setJobTitle("");
                    setDescription("");
                    setIsActive(false);
                }
            } else {
                enqueueSnackbar(jobTitleSave?.Status, { variant: "error" });
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar(error?.response?.data?.Status || "Error while Save Job Title", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} maxWidth={"sm"}>
            <DialogTitle>
                {mode === "add" ? "Add Job Title" : "Edit Job Title"}
            </DialogTitle>

            <DialogContent dividers>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        p: 2,
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }} width={400}>
                        <Box sx={{ width: 120, fontWeight: 500, fontSize: 13 }}>
                            <Typography fontSize={14}>
                                Job Title<span style={{ color: "red", fontSize: "14px" }}>*</span>
                            </Typography>

                        </Box>
                        <TextField
                            value={jobTitle}
                            onChange={(e) => setJobTitle(e.target.value)}
                            size="small"
                            fullWidth
                            sx={compactTextFieldSx}
                        />
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }} width={400}>
                        <Box sx={{ width: 120, fontWeight: 500, fontSize: 13 }}>
                            <Typography fontSize={14}>
                                Description
                            </Typography>
                        </Box>
                        <TextField
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            size="small"
                            multiline
                            rows={1}
                            fullWidth
                            sx={compactTextFieldSx}
                        />
                    </Box>

                    {mode === "edit" && (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ width: 120 }}></Box>
                            <FormControlLabel
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        fontSize: "12px",
                                    },
                                }}
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                }
                                label="Active"
                            />
                        </Box>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    size="small"
                    // sx={ButtonSx}
                    onClick={() => handleSubmit(mode === "add" ? "saveNew" : "update")}
                >
                    {mode === "add" ? "Save & New" : "Update"}
                </Button>

                {/* <Button
                    size="small"
                    sx={ButtonSx}
                    onClick={() => handleSubmit("saveClose")}
                >
                    {mode === "add" ? "Save & Close" : "Delete"}
                </Button> */}
                {mode === "add" && <Button
                    size="small"
                    // sx={ButtonSx}
                    onClick={() => handleSubmit("saveClose")}
                >
                    Save & Close
                </Button>}

                <Button
                    size="small"
                    // sx={ButtonSx}
                    onClick={onClose}
                >
                    Cancel
                </Button>
                <Loader loading={loading} />
            </DialogActions>

        </Dialog>

    );
};

export default EditActionDialog;